import { useMemo } from 'react';
import { useData } from '@grcs/context/DataContext';
import { createAnalyticsService } from '@grcs/utils/analytics/AnalyticsService';

export const useAnalyticsService = () => {
  const { supabase } = useData();

  return useMemo(() => createAnalyticsService(supabase), [supabase]);
};
